import axios from 'axios';


const qyxx = (data) => axios.get('/custom/figure/mine', data);    //企业形像
const qyjj = (data) => axios.get('/custom/brief/mine', data);    //企业简介
const hangye = (data) => axios.get('/custom/position/mine', data);    //行业地位
const culture = (data) => axios.get('/custom/culture/list', data); //企业文化
const information = (data) => axios.get('/custom/information/list', data);//新闻资讯
const team = (data) => axios.get('/custom/team/list', data);
const certification = (data) => axios.get('/custom/qualifications/list', data);//企业资质
const honor = (data) => axios.get('/custom/honor/list', data); //荣誉
const partner = (data) => axios.get('/custom/partners/list', data);
const product = (data) => axios.get('/custom/product/list', data);//产品接受
const course = (data) => axios.get('/custom/course/list', data);//企业历程


export default {
  qyxx,
  qyjj,
  hangye,
  culture,
  information,
  team,
  certification,
  honor,
  partner,
  product,
  course,

}
